import { z } from "zod";

const passwordSchema = z.string().superRefine((val, ctx) => {
  if (val.length < 8) ctx.addIssue({ code: "custom", message: "At least 8 characters" });
  if (!/[A-Z]/.test(val))
    ctx.addIssue({ code: "custom", message: "At least one uppercase letter" });
  if (!/[a-z]/.test(val))
    ctx.addIssue({ code: "custom", message: "At least one lowercase letter" });
  if (!/[0-9]/.test(val)) ctx.addIssue({ code: "custom", message: "At least one number" });
  if (!/[^A-Za-z0-9]/.test(val))
    ctx.addIssue({ code: "custom", message: "At least one special character" });
});

export const validatePassword = (password: string): string | false => {
  if (password === "") return false;

  const result = passwordSchema.safeParse(password);

  if (result.success) return false;

  return result.error.issues.map((i) => i.message).join(", ");
};

export const isPasswordValid = (password: string): boolean =>
  password !== "" && passwordSchema.safeParse(password).success;
